import React from 'react';

const ManageClientConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/teamlead/manageclient',
            component: React.lazy(() => import('./manageClient'))
        }
    ]
};

export default ManageClientConfig;